// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DependentFieldsController from "./dependent_fields_controller"
application.register("dependent-fields", DependentFieldsController)

import DetailsController from "./details_controller"
application.register("details", DetailsController)

import DiffToggleController from "./diff_toggle_controller"
application.register("diff-toggle", DiffToggleController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import MarkdownPreviewController from "./markdown_preview_controller"
application.register("markdown-preview", MarkdownPreviewController)

import RowsController from "./rows_controller"
application.register("rows", RowsController)

import SnapshotPositionController from "./snapshot_position_controller"
application.register("snapshot-position", SnapshotPositionController)

import UploadController from "./upload_controller"
application.register("upload", UploadController)

import UploadStatusController from "./upload_status_controller"
application.register("upload-status", UploadStatusController)
